import { apiRequest } from "../../index";

// Orders Management

export const getAllOrders = async ({page , limit, search = "", status = ""}) => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  
  if (search) {
    params.append("search", search);
  }
  
  if (status) {
    params.append("status", status);
  }
  
  return apiRequest(`/api/owner/hotel-management/orders/all?${params.toString()}`, "GET");
};

export const getOrderDetail = async (orderId) => {
  return apiRequest(`/api/owner/hotel-management/orders/detail/${orderId}`, "GET");
};

export const deleteOrder = async (orderId) => {
  return apiRequest(`/api/owner/hotel-management/orders/${orderId}`, "DELETE" );
};

export const updateOrderStatus = async ({orderId, status}) => {
  return apiRequest(`/api/owner/hotel-management/orders/status/${orderId}`, "PUT", { status });
};